import { render, staticRenderFns } from "./detailComp.vue?vue&type=template&id=3fa02dcc&"
import script from "./detailComp.vue?vue&type=script&lang=ts&"
export * from "./detailComp.vue?vue&type=script&lang=ts&"
import style0 from "./detailComp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports